import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import './assets/styles/custom.scss';
import VueSwal from 'vue-swal';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
import Paginate from 'vuejs-paginate'
import VueBottomDialog from 'vue-bottom-dialog'
import Multiselect from 'vue-multiselect'
import ReadMore from 'vue-read-more';
import haversine from 'haversine-distance'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSwal);
Vue.use(Datetime)
Vue.component('paginate', Paginate)
Vue.use(VueBottomDialog)
Vue.component('multiselect', Multiselect)
Vue.use(ReadMore)
Vue.component('apexchart', VueApexCharts)


// let baseUrl="http://localhost:3000/api/";
let baseUrl = "https://syndicate.staging.property-pistol.in/api/mobile_crm"
if(process.env.NODE_ENV === 'production'){
  // baseUrl = "https://syndicate-network.in/api/mobile_crm"
}
axios.defaults.baseURL = baseUrl;

async function fetchPublicIP() {
  try {
      const response = await fetch('https://api.ipify.org?format=json');
      const data = await response.json();
      return data.ip;
  } catch (error) {
      console.error('Error fetching public IP:', error);
      return null; // Fallback if fetching IP fails
  }
}
//axios interceptors
axios.interceptors.request.use(async function(config) {

  if (config.url === 'enquiries_builders/make_call') {
    store.dispatch('setLoading', false);
  } else if (config.url.includes("access_protected_info")) {
    store.dispatch('setLoading', false);
  } else {
    store.dispatch('setLoading', true);
  }
  if(config.url.indexOf('login') < 0 && config.url.indexOf('/forgot_password') < 0 && config.url.indexOf('/users/password') && config.url.indexOf('googleapis') < 0){
    let token = localStorage.getItem('radiate-crm-token')
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }else{
      return {
        headers: {},
        method: config.method,
        url: ""
      };
    }
  }
  const newIP = await fetchPublicIP();
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  return response;
}, function(error){
  if(error.response.status === 401){
    localStorage.removeItem('radiate-crm-token');
    swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    })
    .then(router.replace('/login'),
    store.dispatch('setLoading', false));
  }else{
    store.dispatch('setLoading', false);
    return Promise.reject(error);
  }
});

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('radiate-crm-token')
  if(token && to.name === 'Login'){
    next({name: 'Home'});
  }else if(to.name !== 'Login' && to.name !== 'ForgotPassword' && to.name !== 'PasswordEdit'  && !token){
    next({name: 'Login'});
  }else{
    if(to.name === 'Login' || to.name ==='ForgotPassword' || to.name==="PasswordEdit" || to.name === 'OTP'){
      store.dispatch('setLayout', 'login');
    }else{
      store.dispatch('setLayout', 'default');
    }
    next();
  }
})

Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
